import { ISpecs } from 'app/models/specs/specs';

import taxelcoLogo from '../../assets/clients/taxelco/logo.png';
import taxiBackground from '../../assets/clients/taxelco/background.jpeg';
import backgroundEXO from '../../assets/clients/taxelco/backgroundEXO.png';
import backgroundSTL from '../../assets/clients/taxelco/backgroundSTL.png';
import footerLogoEXO from '../../assets/clients/taxelco/footerLogoEXO.png';
import footerLogoSTL from '../../assets/clients/taxelco/footerLogoSTL.png';
import mapLogoTaxelco from '../../assets/clients/taxelco/mapLogoTaxelco.png';

import { Authorization, Clients, DistanceUnit, TimeFormat } from 'app/enums/clients';
import { PaymentTypes } from '../components/PaymentDetails/PaymentDetails.model';
import { OrderType } from 'app/enums/order-types';
import { SearchType } from 'app/components/ReservationBar/ReservationBar.model';

export const specsTaxleco: ISpecs = {
  client: Clients.Taxelco,
  languages: ['fr', 'en-ca'],
  languagesFlag: false,
  paymentTypes: [PaymentTypes.CashOnBoard, PaymentTypes.OpusCard, PaymentTypes.Correspondance, PaymentTypes.Free],
  authorization: [Authorization.Email],
  isMultiplePayments: true,
  styles: {
    themeColorPrimary: '#0a0a0a',
    themeColorSecondary: '#3662d8',
    themeColorMuted: '#787878',
    themeColorGradient: 'linear-gradient(90deg, #292424 20%, #000000 100%)',
    themeColorCheckbox: '#2196F3',
    themeColorPrimaryTransparent: '#0a0a0a52',
    themeColorSecondaryTransparent: '#e7edfd',
    themeTextColorPrimary: 'rgb(63, 63, 63)',
    themeTextColorSecondary: 'rgb(110, 110, 110)',
    themeTextColorError: 'rgba(250, 8, 8, 0.87)',
    themeCardBorderRadius: '8px',
    themeCardPadding: '8px',
    maxSizeWidth: '1400px',
    toolbarHeight: '80px',
    footerHeight: '40px',
  },
  toolbar: {
    logo: taxelcoLogo,
  },
  footer: {
    text: '',
  },
  reservationBar: {
    tabs: [OrderType.Shuttle],
    defaultTab: OrderType.Shuttle,
    shuttleSearchType: [SearchType.Line],
  },
  pages: {
    home: {
      titleColor: 'white',
      titleShadow: true,
      suppliersUI: {
        default: {
          backgroundImage: taxiBackground,
          topRightImage: null,
          footerImage: null,
        },
        EXO: {
          backgroundImage: backgroundEXO,
          topRightImage: mapLogoTaxelco,
          footerImage: footerLogoEXO,
        },
        STL: {
          backgroundImage: backgroundSTL,
          topRightImage: mapLogoTaxelco,
          footerImage: footerLogoSTL,
        }
      },
      backgroundShadow: true,
      reviewes: false,
    },
  },
  maxSeats: 2,
  contact: {
    phone: '514-273-2704',
    email: 'collectif@taxelco.com',
    address: '2901 Rue Rachel Est, Suite 20 Montréal (Québec)  H1W 4A4',
  },
  timeFormat: TimeFormat.Time12,
  distanceUnit: DistanceUnit.MI,
};
